import React from "react";
import { PlusIcon, PencilIcon, TrashIcon } from "lucide-react";
import AddServiceFormWrapper from "../Add/AddServiceFormWrapper";

const VendorServiceView = ({
  isFormOpen,
  setIsFormOpen,
  editingService,
  setEditingService,
  vendorServices,
  handleAddService,
  handleEditService,
  handleDeleteService,
  isServiceLoading,
}) => {
  const skeletonArray = new Array(10).fill(null);
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Service Management
          </h2>
          <p className="text-sm text-gray-600">Manage your service offerings</p>
        </div>
        <button
          onClick={() => {
            setEditingService(null);
            setIsFormOpen(true);
          }}
          className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg flex items-center"
        >
          <PlusIcon size={16} className="mr-2" />
          Add Service
        </button>
      </div>

      {/* Service List */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Service
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Duration
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Price
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {isServiceLoading ? (
                skeletonArray.map((_, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="w-3 h-3 rounded-full mr-3 bg-gray-300 animate-pulse" />
                        <div>
                          <div className="w-24 h-4 bg-gray-300 rounded animate-pulse mb-1"></div>
                          <div className="w-32 h-3 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="w-20 h-6 bg-gray-200 rounded-full animate-pulse"></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="w-20 h-4 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="w-12 h-4 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right">
                      <div className="flex justify-end gap-4">
                        <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
                        <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
                      </div>
                    </td>
                  </tr>
                ))
              ) :
               !vendorServices?.length ? (
                <div className='hidden' >
               
                </div>
              ) : (
                vendorServices?.map((service) => (
                  <tr key={service.id}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div
                          className="w-3 h-3 rounded-full mr-3"
                          style={{ backgroundColor: service.color_code }}
                        />
                        <div>
                          <div className="text-sm font-medium text-gray-900">
                            {service.name}
                          </div>
                          <div className="text-sm text-gray-500">
                            {service.description}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 py-1 text-xs font-medium bg-gray-100 rounded-full">
                        {service.category  || ""}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {service.duration} min
                      {service.buffer_time > 0 && (
                        <span className="text-xs text-gray-400">
                          {" "}
                          (+{service.buffer_time} buffer)
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      ${service.price}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <button
                        onClick={() => {
                          setEditingService(service);
                          setIsFormOpen(true);
                        }}
                        className="text-[#332d56] hover:text-[#4a4178] mr-4"
                      >
                        <PencilIcon size={16} />
                      </button>
                      <button
                        onClick={() => handleDeleteService(service.id)}
                        className="text-red-600 hover:text-red-900"
                      >
                        <TrashIcon size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            
          </table>
          {(!vendorServices?.length && !isServiceLoading)  && <div className="p-8 flex justify-center items-center">
                 <div>
                   <p className="text-gray-500">No services added yet.</p>
                  <button
                    onClick={() => {
                      setEditingService(null);
                      setIsFormOpen(true);
                    }}
                    className="mt-2 text-orange-500 hover:text-orange-600"
                  >
                    Click here to add your first service
                  </button>
                 </div>
                </div>}
        </div>
      </div>

      {/* Modal */}
      <AddServiceFormWrapper
        isOpen={isFormOpen}
        onClose={() => {
          setIsFormOpen(false);
          setEditingService(null);
        }}
        onSubmit={editingService ? handleEditService : handleAddService}
        editingService={editingService || undefined}
      />
    </div>
  );
};

export default VendorServiceView;